var h1 = document.querySelector('h1');
var main = document.querySelector('main');
var button = document.getElementById('BackToTop');
var target = h1 || main;
var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
if (button) {
  button.addEventListener('click', function (e) {
    e.preventDefault();
    if (target) {
      target.scrollIntoView({
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
        block: 'center'
      });
      setTimeout(function () {
        target.focus();
      }, 1000);
    } else {
      window.scrollTo({
        top: 0,
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
        block: 'center'
      });
      setTimeout(function () {
        document.body.focus();
      }, 1000);
    }
  });
  window.addEventListener('scroll', function () {
    button.classList.toggle('visible', window.scrollY > window.innerHeight / 2);
  }, {
    passive: true
  });
}